<template>
  <chart-card title="Cadastros" filter-button :filter-type.sync="filterType" :data="chartData" :chart-loading="loading" is-integer />
</template>

<script>
import ChartCard from '@/components/ChartCard.vue'
import { mapState } from 'vuex'
import { mapWaitingActions } from 'vue-wait'
import * as helpers from '@/config/helpers.js'
import { colors } from '@/config/colors.js'

export default {
  components: {
    ChartCard,
  },
  data: () => ({
    filterType: 'mensal',
    listaCadastrosMensal: [],
    listaCadastrosSemanal: [],
    listaCadastrosDiario: [],
    loading: true,
  }),
  computed: {
    ...mapState({
      stateFilters: (state) => state.filters,
    }),
    filtro() {
      return {
        unidades: this.stateFilters.unitsConfiguration,
        segmentos: this.stateFilters.segments,
      }
    },
    cadastros() {
      if (this.filterType === 'mensal') return this.cadastrosMensal
      if (this.filterType === 'semanal') return this.cadastrosSemanal
      if (this.filterType === 'diario') return this.cadastrosDiario
      return ''
    },
    cadastrosMensal() {
      return helpers.agrupamentoMensal(this.listaCadastrosMensal, 'NUM_CLIENTES_CADASTRADOS')
    },
    cadastrosSemanal() {
      return helpers.agrupamentoSemanal(this.listaCadastrosSemanal, 'NUM_CLIENTES_CADASTRADOS')
    },
    cadastrosDiario() {
      return helpers.agrupamentoDiario(this.listaCadastrosDiario, 'NUM_CLIENTES_CADASTRADOS')
    },
    chartData() {
      return {
        labels: [...this.cadastros.map((object) => object.data)],
        datasets: [
          {
            label: 'Cadastros',
            backgroundColor: colors[0],
            strokeColor: colors[0],
            borderColor: colors[0],
            data: [...this.cadastros.map((object) => object.valor)],
            fill: false,
          },
        ],
      }
    },
  },
  watch: {
    filterType() {
      this.getData()
    },
  },
  async mounted() {
    this.$bus.$on('filter', this.getData)

    this.$nextTick(async () => {
      await this.getData()
    })
  },
  destroyed() {
    this.$bus.$off('filter')
  },
  methods: {
    ...mapWaitingActions({
      empresaClientesChart: 'clientes-cadastrados',
    }),
    async getData() {
      try {
        this.loading = true
        if (this.filterType === 'mensal') {
          await this.empresaClientesChart({ group_field: 'ano,mes', ...this.filtro }).then((data) => {
            this.listaCadastrosMensal = data
          })
        } else if (this.filterType === 'semanal') {
          await this.empresaClientesChart({ group_field: 'ano,semana', ...this.filtro }).then((data) => {
            this.listaCadastrosSemanal = data
          })
        } else if (this.filterType === 'diario') {
          await this.empresaClientesChart({ group_field: 'anomesdia', ...this.filtro }).then((data) => {
            this.listaCadastrosDiario = data
          })
        }
      } catch (error) {
        console.log(error)
      } finally {
        this.loading = false
      }
    },
  },
}
</script>
